// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "9d45035e",
    "hash": "9d45035e",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "9d45035e",
    "semverString": null,
    "version": "2026.8.0.34"
};
/* tslint:enable */
